module.exports = __webpack_public_path__ + "pc/img/icon5.c0a9f3d0.png";